(function () {
  function initRec(wrap) {
    var track = wrap.querySelector('[data-recs-track]');
    var dotsWrap = wrap.querySelector('.penta-recs-pagination');
    if (!track) return;

    var productCount = dotsWrap ? parseInt(dotsWrap.getAttribute('data-product-count'), 10) : 0;
    var pageCount = Math.ceil(productCount / 2);
    var currentPage = 0;

    // Build pagination dashes
    if (dotsWrap && pageCount > 1) {
      for (var i = 0; i < pageCount; i++) {
        var dot = document.createElement('span');
        dot.className = 'penta-recs-dot' + (i === 0 ? ' is-active' : '');
        dotsWrap.appendChild(dot);
      }
    }

    function updateDots(page) {
      if (!dotsWrap) return;
      dotsWrap.querySelectorAll('.penta-recs-dot').forEach(function (d, i) {
        d.classList.toggle('is-active', i === page);
      });
    }

    function goToPage(page) {
      page = Math.max(0, Math.min(page, pageCount - 1));
      currentPage = page;
      track.scrollTo({ left: page * track.offsetWidth, behavior: 'smooth' });
      updateDots(page);
    }

    var prevBtn = wrap.querySelector('.penta-recs-arrow--prev');
    var nextBtn = wrap.querySelector('.penta-recs-arrow--next');
    if (prevBtn) prevBtn.addEventListener('click', function () { goToPage(currentPage - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goToPage(currentPage + 1); });

    // Sync dots on swipe
    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var page = Math.round(track.scrollLeft / track.offsetWidth);
        if (page !== currentPage) {
          currentPage = page;
          updateDots(page);
        }
      }, 80);
    }, { passive: true });
  }

  function checkForRecs() {
    document.querySelectorAll('.penta-recs-wrap:not([data-penta-init])').forEach(function (wrap) {
      wrap.setAttribute('data-penta-init', '1');
      initRec(wrap);
    });
  }

  // Catch AJAX-injected recommendations
  var observer = new MutationObserver(function (mutations) {
    var found = false;
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if ((node.classList && node.classList.contains('penta-recs-wrap')) ||
            (node.querySelector && node.querySelector('.penta-recs-wrap'))) {
          found = true;
        }
      });
    });
    if (found) checkForRecs();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkForRecs);
  } else {
    checkForRecs();
  }
})();
